// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1uIR7","title":"AfterFrontImage_title__3RMyO"};